import { Outlet, useOutletContext } from 'react-router-dom';
import { ModalNavigationContext } from 'components/pages/ConsultantPage/ConsultantPage';

export const ModalNavigationOutlet = () => {
  const modalNavigationContext = useOutletContext<ModalNavigationContext>();

  return <Outlet context={modalNavigationContext} />;
};
